export default "__VITE_ASSET__8d0bde31__"